module.exports = __webpack_public_path__ + "img/008-009.7f1e18b0.jpg";